<h2 mat-dialog-title>Notes</h2>
<mat-dialog-content class="mat-typography">
    {{data.notesData}}
</mat-dialog-content>